import { environment } from './environments/environment';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import posthog from 'posthog-js';
import { AppModule } from './app/app.module';

if (environment.production) {
  Sentry.init({
    dsn: environment.sentrySDK,
    environment: environment.sentryEnv,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    normalizeDepth: 5,
  });

  posthog.init('phc_OyP7YlwrOmcdZCnb0U8c5x33wFREIUp3ndc5FIpMy90', {
    api_host: 'https://eu.i.posthog.com',
    autocapture: false,
    person_profiles: 'always',
    defaults: '2025-05-24',
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err: unknown) => {
    if (err instanceof Error) {
      console.error(err.message);
    } else {
      console.error(err);
    }
  });
